/**
 * @voltxampere/web — Pane category builtin commands (Sprint 22 C3)
 *
 * 6 navigation commands. Five drive the Sprint 18 hash router to
 * AÇILIŞ / SİMÜLATÖR / DEVRELER / INSPECTOR / AYARLAR; one toggles
 * the shortcut overlay (alternative to the `?` key). Pane shortcuts
 * 1-5 already live in the canvas catalog — palette versions are a
 * discovery surface, not a duplicate handler.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import type { Command } from "../types.js";
import { setPane } from "../../store/router.js";
import { shortcutOverlayOpen } from "../../store/ui.js";

export const PANE_COMMANDS: readonly Command[] = [
  {
    id: "pane.landing",
    titleKey: "command.pane.landing",
    category: "pane",
    shortcut: "1",
    execute: () => {
      setPane("landing");
    },
  },
  {
    id: "pane.simulator",
    titleKey: "command.pane.simulator",
    category: "pane",
    shortcut: "2",
    execute: () => {
      setPane("simulator");
    },
  },
  {
    id: "pane.presets",
    titleKey: "command.pane.presets",
    descriptionKey: "command.pane.presets.desc",
    category: "pane",
    shortcut: "3",
    execute: () => {
      setPane("presets");
    },
  },
  {
    id: "pane.inspector",
    titleKey: "command.pane.inspector",
    category: "pane",
    shortcut: "4",
    execute: () => {
      setPane("inspector");
    },
  },
  {
    id: "pane.settings",
    titleKey: "command.pane.settings",
    category: "pane",
    shortcut: "5",
    execute: () => {
      setPane("settings");
    },
  },
  {
    id: "pane.shortcuts-overlay",
    titleKey: "command.pane.shortcutsOverlay",
    descriptionKey: "command.pane.shortcutsOverlay.desc",
    category: "pane",
    shortcut: "?",
    execute: () => {
      shortcutOverlayOpen.value = !shortcutOverlayOpen.value;
    },
  },
];
